import { render } from "./doctorIndex.vue?vue&type=template&id=c0125d68&scoped=true"
import script from "./doctorIndex.vue?vue&type=script&lang=js"
export * from "./doctorIndex.vue?vue&type=script&lang=js"

import "./doctorIndex.vue?vue&type=style&index=0&id=c0125d68&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0125d68"]])

export default __exports__